/* Terra Lua theme — JS mínimo e sem dependências externas */
(function () {
  'use strict';

  // Menu mobile
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      var menu = document.querySelector('[data-mobile-menu]');
      if (menu) {
        menu.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', menu.classList.contains('is-open'));
      }
    }

    // Quantidade +/-
    var qtyBtn = event.target.closest('[data-qty]');
    if (qtyBtn) {
      var wrapper = qtyBtn.closest('.quantity');
      var input = wrapper && wrapper.querySelector('input');
      if (input) {
        var min = parseInt(input.min || '1', 10);
        var value = parseInt(input.value || '1', 10);
        value += qtyBtn.dataset.qty === 'plus' ? 1 : -1;
        input.value = Math.max(min, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Galeria de produto
    var thumb = event.target.closest('[data-thumb]');
    if (thumb) {
      var gallery = thumb.closest('[data-gallery]');
      var main = gallery && gallery.querySelector('[data-gallery-main] img');
      if (main) {
        main.src = thumb.dataset.image;
        main.srcset = '';
      }
      gallery.querySelectorAll('[data-thumb]').forEach(function (el) {
        el.setAttribute('aria-current', el === thumb ? 'true' : 'false');
      });
    }
  });

  // Auto-submit de formulários do carrinho e da ordenação
  document.addEventListener('change', function (event) {
    var form = event.target.closest('[data-auto-submit]');
    if (form) form.submit();
  });

  // Seleção de variantes na página de produto
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    var data = JSON.parse(picker.querySelector('[data-variant-json]').textContent);
    var idInput = picker.querySelector('[data-variant-id]');
    var priceEl = picker.querySelector('[data-variant-price]');
    var submit = picker.querySelector('[data-add-to-cart]');

    picker.addEventListener('change', function () {
      var selected = Array.from(picker.querySelectorAll('input[type="radio"]:checked')).map(function (i) {
        return i.value;
      });
      var match = data.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selected[index];
        });
      });
      if (!match) return;

      idInput.value = match.id;
      if (priceEl && match.price_html) priceEl.innerHTML = match.price_html;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? submit.dataset.labelAvailable : submit.dataset.labelSoldOut;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());

      if (match.featured_image) {
        var main = document.querySelector('[data-gallery-main] img');
        if (main) { main.src = match.featured_image; main.srcset = ''; }
      }
    });
  });

  // Atualiza o contador do carrinho após adicionar via fetch
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  // Add to cart assíncrono (form de produto e quick add)
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-ajax-cart]');
    if (!form) return;
    event.preventDefault();
    var button = form.querySelector('[type="submit"]');
    if (button) button.disabled = true;

    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCartCount(); })
      .catch(function () { form.submit(); })
      .finally(function () { if (button) button.disabled = false; });
  });
})();
